module.exports = __webpack_public_path__ + "static/media/MaisonNeue-MediumItalic.fcc9c05c.woff";